// Promise-mutex for token refresh.
// Ensures only one refresh request is in flight at a time.
// All concurrent 401 handlers wait on the same promise instead of each firing a separate refresh call.
let refreshPromise = null;

export const getRefreshPromise = () => refreshPromise;

export const setRefreshPromise = (promise) => {
	refreshPromise = promise;
};

export const clearRefreshPromise = () => {
	refreshPromise = null;
};
